import { forwardRef, useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";

export interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  hideLabel?: string;
  showLabel?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput(
    { className, disabled, hideLabel = "隐藏密码", showLabel = "显示密码", ...inputProps },
    ref,
  ) {
    const [visible, setVisible] = useState(false);
    const actionLabel = visible ? hideLabel : showLabel;
    const Icon = visible ? EyeOff : Eye;

    return (
      <div className="password-input">
        <input
          {...inputProps}
          className={className}
          disabled={disabled}
          ref={ref}
          type={visible ? "text" : "password"}
        />
        <button
          aria-label={actionLabel}
          aria-pressed={visible}
          className="password-input__toggle"
          disabled={disabled}
          onClick={() => setVisible((current) => !current)}
          type="button"
        >
          <Icon aria-hidden="true" size={20} strokeWidth={2} />
        </button>
      </div>
    );
  },
);
